import type { TicketBlueprint as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type { TicketBlueprintKind } from './TicketBlueprintKind';
import type { TicketSellableThrough } from './TicketSellableThrough';

/** A sellable ticket or add-on of an event, as the Ticketing modal reads it — not checkout's `CheckoutTicketBlueprint`. */
export type TicketBlueprint = {
  id: number;
  eventId: number;
  name: string;
  kind: TicketBlueprintKind;
  orderPriority: number;
  /** Null when the ticket sells to its section limit (ADR-014 decision 5) — never read it as zero. */
  allotment: number | null;
  sectionId: number | null;
  sellStart?: string;
  sellEnd?: string;
  description: string | null;
  price: number | null;
  fee: number | null;
  dependencyId: number | null;
  sellableThrough: TicketSellableThrough[];
  minimum: number | null;
  maximum: number | null;
  multiple: number | null;
};

export const fromGql = (item: GQLItem): TicketBlueprint => ({
  ...take<TicketBlueprint>(item, 'id', 'eventId', 'name', 'kind', 'orderPriority'),
  allotment: item.allotment ?? null,
  sectionId: item.sectionId ?? null,
  sellStart: item.sellStart ?? undefined,
  sellEnd: item.sellEnd ?? undefined,
  description: item.description ?? null,
  price: item.price ?? null,
  fee: item.fee ?? null,
  dependencyId: item.dependencyId ?? null,
  sellableThrough: item.sellableThrough ?? [],
  minimum: item.minimum ?? null,
  maximum: item.maximum ?? null,
  multiple: item.multiple ?? null,
});
